export default function useFormState<T = any>(fetcher: any) {
  const data = fetcher.data as T;
  const isSubmitting = fetcher.state === 'submitting';
  const isLoading = fetcher.state === 'loading';
  const isSuccessful = data?.toast?.status === 'success';
  const isFailed = data?.toast?.status === 'error';

  return {
    fetcher,
    data,
    isSubmitting,
    isLoading,
    isSuccessful,
    isFailed,
  };
}
